export class SidekickIntegration {
  id: string;
  name: string;
  imageLocation: string;
  cta: null;
  authTypeID: number;
  helpdesk: boolean;
  ecommerce: boolean;
  subscription: boolean;
  shipper: boolean;
  carrier: boolean;
  returnService: boolean;
  knowledgeBase: boolean;
  authType: string;
  createdAt: string;
  customerID: number;
  customerIntegrationID: number;
  authFailed: boolean;
}
